import { Match } from "model/Match/Match";
import { getDefinedRosterIds } from "./Roster";
import { unique } from "Utility";
import { RosterScope } from "./RosterScope";

export type ScopedRosterId = {
  id: string;
  scope: RosterScope;
};

const scopedRosterIdsEqual = (r1: ScopedRosterId, r2: ScopedRosterId) =>
  r1.id === r2.id && r1.scope === r2.scope;

const getMatchScopedRosterIds = (match: Match) => {
  return getDefinedRosterIds(match.teams.rosters).map((id) => ({
    id,
    scope: match.teams.scope,
  }));
};

export const getMatchesScopedRosterIds = (matches: Match[]) => {
  return unique(
    matches.flatMap((m) => getMatchScopedRosterIds(m)),
    scopedRosterIdsEqual
  );
};
